import { Component } from "react";
import { observable } from "mobx";
import { observer, useLocalObservable } from "mobx-react";
import { Modal, Typography, Input } from "antd";
import { translateKey as t } from "../../../locales/translation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

const { Title } = Typography;

const CrudDeleteModal = observer(
  ({
    controller,
    modalProps,
  }: {
    controller?: any;
    modalProps: {
      visible: boolean;
      onConfirmDelete: Function;
      description?: string | JSX.Element;
      verificationField?: string;
    };
  }) => {
    const state = useLocalObservable(() => ({
      deleteText: "",

      setDeleteText(value: string) {
        this.deleteText = value;
      },
    }));

    const renderDescription = () => {
      if (modalProps.description) {
        return <p style={{ alignSelf: "center" }}>{modalProps.description}</p>;
      }

      if (controller) {
        const { tableInstance } = controller;
        const selectedRowsCount: number = tableInstance && tableInstance.multiSelectedRows.totSelected;

        if (selectedRowsCount === 1) {
          return <p style={{ alignSelf: "center" }}>{t("lblAreYouSureYouWantToDeleteOneItem", "Are you sure you want to delete 1 item?")}</p>;
        } else {
          return <p style={{ alignSelf: "center" }}>{t("lblAreYouSureYouWantToDeleteCountItems", "Are you sure you want to delete {1} items?", [selectedRowsCount])}</p>;
        }
      }

      return null;
    };

    const handleOK = () => {
      modalProps.onConfirmDelete();
      state.setDeleteText("");
      modalProps.visible = false;
    };

    const handleCancel = () => {
      state.setDeleteText("");
      modalProps.visible = false;

      if (controller) {
        controller.tableInstance.resetMultiselectedRows();
        // controller.selectedRows = []
      }
    };

    return (
      <Modal
        open={modalProps.visible}
        cancelText={t("lblCancel", "Cancel")}
        okText={t("lblDelete", "Delete")}
        onCancel={handleCancel}
        centered={true}
        okType="danger"
        okButtonProps={{ disabled: state.deleteText !== (modalProps.verificationField || "delete") }} //modalProps.clientRef }}
        onOk={handleOK}
      >
        <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "space-around" }}>
          <Title level={4} style={{ width: "max-content", alignSelf: "center" }}>
            {t("lblAreYouSure", "Are you sure?")}
          </Title>
          <FontAwesomeIcon icon={faTrash} style={{ fontSize: "60px", padding: "10px 0px" }} />
          {/* <Icon type={'delete'} theme='twoTone' twoToneColor='red' style={{ fontSize: '60px', padding: '10px 0px' }} /> */}
          {renderDescription()}
          <strong style={{ alignSelf: "center" }}>{t("lblThisProcessCannotBeReversed", "This process cannot be reversed.")}</strong>
          <Input
            data-e2e="delete-modal-confirm-deletion"
            onChange={(e) => state.setDeleteText(e.target.value)}
            value={state.deleteText}
            maxLength={20}
            size="small"
            style={{ marginTop: "20px" }}
            placeholder={t("lblTypeInClientRefToConfirmDeletion", "Type in client Ref to confirm deletion")}
            autoComplete="newpassword"
          ></Input>
        </div>
      </Modal>
    );
  }
);

export { CrudDeleteModal };
